import React, { Children } from "react";
import styled, { css } from "styled-components";

/* Une grille / pile dont toutes les cartes sont masquées ne rend rien */
const hideWhenEmpty = (Component) => {
    const Wrapped = ({ children, ...props }) =>
        Children.toArray(children).length ? (
            <Component {...props}>{children}</Component>
        ) : null;
    return Wrapped;
};

/**
 * Grille responsive : `cols` = 2 | 3 | 4.
 * 980px → 2 colonnes, 620px → 1 colonne.
 */
const GridBase = styled.div`
    display: grid;
    gap: var(--prh-space-md);
    grid-template-columns: repeat(${({ cols = 3 }) => cols}, 1fr);
    ${({ $mb }) =>
        $mb &&
        css`
            margin-bottom: var(--prh-space-md);
        `}
    ${({ $mt }) =>
        $mt &&
        css`
            margin-top: var(--prh-space-md);
        `}

    @media (max-width: 980px) {
        ${({ cols }) =>
            cols >= 3 &&
            css`
                grid-template-columns: repeat(2, 1fr);
            `}
    }
    @media (max-width: 620px) {
        grid-template-columns: 1fr;
    }
`;

/** Pile verticale de cartes (dans une colonne de grille) */
const StackBase = styled.div`
    display: grid;
    gap: var(--prh-space-md);
    align-content: start;
`;

export const Grid = hideWhenEmpty(GridBase);
export const Stack = hideWhenEmpty(StackBase);
